import { AddProcessRequestSchema, AddProcessResponseSchema } from './add-process.schema';
/**
 * Add Process Endpoint Contract
 * Creates a new process in the system
 * Requires authenticated user with appropriate permissions
 */ export const addProcessContract = {
    method: 'POST',
    path: '/api/v2/process',
    description: 'Create a new process with specified owner, department, and details',
    requestSchema: AddProcessRequestSchema,
    responseSchema: AddProcessResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions'
        }
    }
};

//# sourceMappingURL=add-process.contract.js.map